module.exports = __webpack_public_path__ + "static/media/ask_a_question.815ecc91.svg";